import cookie from 'js-cookie';

import { WEBSITE_TOKEN_COOKIE } from '@farmersdog/constants';
import { getTokenExpiration } from './getTokenExpiration';

export function setTokenCookie(token: string) {
  const expires = getTokenExpiration(token);
  cookie.set(WEBSITE_TOKEN_COOKIE, token, { expires });
}
